export default "__VITE_ASSET__Bc92v1Lq__"